import { sdk } from '@farcaster/miniapp-sdk'

export let isBaseMiniApp = false

export async function initializeBaseMiniApp() {
  isBaseMiniApp = await sdk.isInMiniApp()
}
